module.exports = __webpack_public_path__ + "static/media/KitchenCabinet_Before.b1b65a99.jpg";